import apiHeader from '@/helpers/apiHeader';

/**
 * Service generic untuk semua menu General Master Data.
 *
 * Endpoint dipakai berdasarkan `resource` (slug) yang dikirim dari route.meta.
 * Selama BE punya pola URL `general-master-data/{slug}`, cukup ganti slug-nya.
 *
 * Contoh slug yang dipakai sekarang:
 *   - mrp-group  → 'gm-mrp-groups'
 *   - mrp-type   → 'mrp-types'
 */
const generalMasterDataService = {
    list(resource, params) {
        return apiHeader.get(`general-master-data/${resource}`, { params });
    },
    export(reportType, client) {
        return apiHeader.get('general-master-data/export', {
          params: { type: reportType, client: client },
          responseType: 'blob'
        });
    },
    // Download template import (xlsx) untuk resource tertentu.
    downloadTemplate(resource) {
        return apiHeader.get(`general-master-data/${resource}/template`, {
            responseType: 'blob'
        });
    },
    // Import file excel/csv untuk resource tertentu.
    importData(resource, file) {
        const fd = new FormData();
        fd.append('file', file);
        return apiHeader.post(`general-master-data/${resource}/import`, fd, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });
    }
};

export default generalMasterDataService;
